import React from "react";
import { formatBalance } from "../../../../Helpers/Pricing";

import { Row, Skeleton, Tooltip } from "antd";
import GlobalTooltipIcon from "../../Common/GlobalTooltipIcon";
import "./index.scss";
import NotFoundCard from "../../Common/NotFoundCard";
import ErrorCard from "../../Common/ErrorCard";

const AddedInWallet = (props) => {
  const {
    data,
    startDate,
    endDate,
    loading,
    error,
    errorMsg,
    errorCode,
  } = props;

  function amountHandler(amount, color) {
    if (!!amount) {
      if (color === "yellow") {
        return (
          <div className="delivered-order-head yellow">
            ₹ {formatBalance(amount)}
          </div>
        );
      } else {
        return (
          <div className="delivered-order-head credit">
            ₹ {formatBalance(amount)}
          </div>
        );
      }
    } else {
      return <div className="delivered-order-head ">0</div>;
    }
  }

  if (loading) {
    return (
      <Row style={{ marginBottom: "30px" }}>
        <Skeleton active />
      </Row>
    );
  }

  if (!loading && error) {
    return (
      <div id="fade-in" className="deductedFromWallet">
        <div className="topPerformingProductHead">
          {" "}
          <span className="name">Money Added In Wallet</span> |{" "}
          <span>
            {startDate} - {endDate}
          </span>
        </div>

        <ErrorCard errorMsg={errorMsg} errorCode={errorCode} />
      </div>
    );
  }

  if (Object.entries(data).length === 0) {
    return (
      <div id="fade-in" className="deductedFromWallet">
        <div className="topPerformingProductHead">
          {" "}
          <span className="name">Money Added In Wallet</span> |{" "}
          <span>
            {startDate} - {endDate}
          </span>
        </div>

        <NotFoundCard
          mainHeading={"Oops! No Data Found."}
          secondHeading={
            <p>
              Looks like there are no data in <span>current Date Range</span>.
            </p>
          }
          thirdHeading={
            <p>
              Please <span>select another Date Range</span> from Date Picker to
              filter data.
            </p>
          }
        />
      </div>
    );
  }
  return (
    <div id="fade-in" className="deductedFromWallet">
      <div className="topPerformingProductHead">
        {" "}
        <span className="name">Money Added In Wallet</span> |{" "}
        <span>
          {startDate} - {endDate}
        </span>
      </div>
      <div className="product-heads">
        <div className="name-head">Source</div>
        <div className="delivered-order-head">Pending</div>
        <div className="delivered-order-head">Processed</div>
      </div>

      <div className="product-row-wraper">
        {parseInt(data.processed_buyback_credit_pp) > 0 && (
          <div className="product-row">
            <div className="name-head">
              Buyback Credit Product Price
              {/* <GlobalTooltipIcon
           tooltipText={
             "This is a Global Value and does not relate to any specific store."
           }
         /> */}
            </div>
            {amountHandler(0)}
            {amountHandler(data.processed_buyback_credit_pp)}
          </div>
        )}

        <div className="product-row">
          <div className="name-head">COD </div>
          {amountHandler(data.pending_cod_remit_amount, "yellow")}
          {amountHandler(data.processed_cod_remit_amount)}
        </div>
        <div className="product-row">
          <div className="name-head">Prepaid Remittance</div>
          {amountHandler(data.pending_prepaid_remit_amount, "yellow")}
          {amountHandler(data.processed_prepaid_remit_amount)}
        </div>

        {!!data.rto_remit_credit || data.pending_rto_remit_credit ? (
          <div className="product-row">
            <div className="name-head">RTO Remit</div>
            {amountHandler(data.pending_rto_remit_credit, "yellow")}
            {amountHandler(data.rto_remit_credit)}
          </div>
        ) : null}

        {/* <div className="product-row">
          <div className="name-head">Remittance Pending</div>
          {amountHandler(data.pending_cod_remit_amount, "yellow")}
        </div> */}

        <div className="product-row last-row">
          <div className="name-head total">Total</div>
          {amountHandler(
            0 +
              data.pending_cod_remit_amount +
              (!!data.pending_prepaid_remit_amount?data.pending_prepaid_remit_amount:0) +
              (!!data.pending_rto_remit_credit ? data.pending_rto_remit_credit : 0),
            "yellow"
          )}
          {amountHandler(
            data.processed_buyback_credit_pp +
              data.processed_cod_remit_amount +
              data.processed_prepaid_remit_amount +
              (!!data.rto_remit_credit ? data.rto_remit_credit : 0)
          )}
        </div>
      </div>
    </div>
  );
};

export default AddedInWallet;
